import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import { creator, errorMessageGenerator } from 'uwork-app-core';
import axios from 'utils/axios';

/**
 * Constants
 */
export const REQUEST = '@app/company/tabs/team/get/REQUEST';
export const SUCCESS = '@app/company/tabs/team/get/SUCCESS';
export const FAILURE = '@app/company/tabs/team/get/FAILURE';
export const CLEAR = '@app/company/tabs/team/get/CLEAR';
export const UPDATE = '@app/company/tabs/team/update/UPDATE';

/**
 * Initial state
 */
const initState = {
    data: [],
    loading: false,
    error: ''
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                draft.data = [];
                draft.loading = true;
                draft.error = '';
                break;
            case SUCCESS:
                draft.data = payload;
                draft.loading = false;
                break;
            case FAILURE:
                draft.loading = false;
                draft.error = payload;
                break;
            case CLEAR:
                draft.data = [];
                draft.loading = false;
                draft.error = '';
                break;
            case UPDATE:
                draft.data = draft.data.map((el) =>
                    el.user.id === payload.user.id ? payload : el
                );
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    update: (data) => creator(UPDATE, data),
    clear: () => creator(CLEAR)
};

/**
 * Saga functions
 */
export const sagas = {
    *request({ payload }) {
        try {
            const response = yield axios.get(`/companies/team/${payload}`);
            yield put(actions.success(response.data.data));
        } catch (e) {
            yield put(actions.failure(errorMessageGenerator(e)));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
